<template>
  <v-card
    class="px-3 py-2 my-3 mx-2"
    outlined
    max-width="430"
  >
    <div class="d-flex flex-row">
      <div class="image-content d-flex justify-center align-center mr-3"> 
        <img class="ml-auto mr-auto no-flex" :src="getFoto(articulo)" height="100" width="100">
      </div>
      <div>
          <p class="mb-2 grey--text">Loc. {{ articulo.localizador}}</p>
          <h2 class="text-uppercase title mb-1 mt-1 primary-color mb-0">{{ articulo.modelo }}  </h2>
          <p class="mb-1 text-uppercase subheading">{{ articulo.color }}</p>
        </div>
        
    </div>
    <div class="d-flex h1 justify-between align-center">
          <!-- <v-select
                :items="articulo.tallas"
                placeholder=""
                label="Talla"
                v-model="tallaInterna"
                item-text="talla"
                item-value="tallaInterna"
                class="mr-3 title"
                auto
                />
          <div class="d-flex no-flex align-center mr-2">
            <v-btn icon small class="primary" @click="restar()">
               <v-icon>remove</v-icon>
            </v-btn>
            <v-text-field class="headline " name="unishop-item-quantity" v-model.number="cantidad"></v-text-field>
            <v-btn icon small class="primary" @click="sumar()">
              <v-icon>add</v-icon>
            </v-btn>
          </div> -->
            <div class="mr-3 no-flex headline font-weight-bold">{{ formatMoney(precio) }}</div>
          <!-- <v-btn fab flat class="orange no-flex ma-0 d-flex mr-3" href="#"  @click="addToCart()">
            <v-icon class="white--text">add_shopping_cart</v-icon>
          </v-btn>  -->
      </div>
      
    <div class="d-flex justify-end">   
    </div>
    <div v-if="error"> {{ errorMsj }} </div>
  </v-card>
</template>
<script>
import { TiendaApiService } from '@/api/TiendaApiService'
import { Util } from '@/api/Util'

const tiendaApiService = new TiendaApiService()
const util = new Util()

export default {
  name: "LookArticulo",
  props: ['articulo'],
  data() {
    return {
      cantidad: 1,
      tallaInterna: '',
      talla: '',
      precio: '',
      precios: [],
      codigo: '',
      medidas:[],
      medida: '',
      unidadesDisp: 0,
      stock: [[]],
      foto: '',
      tallas: [],
      total:[],
      ops : [],
      error: false,
      errorMsj: '',
      opId: this.$store.getters.getIdTienda,
      tiendas: this.$store.state.iniOps,
    }
  },
  computed: {
    cambiotienda () {
      return this.$store.getters.getIdTienda;
    }
  },
  watch: {
    cambiotienda (value) {
      this.opId = value
      this.init()
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.getStock()
      this.getPrecios()
    },
    getPrecios(){
      tiendaApiService.getPreciosByIdArtandIdOp(this.articulo.id)
        .then(data => {
          // util.mostrarEnConsola('tiendaApiService - getPreciosByIdArtandIdOp', data.length, 'OK')
          this.precios = data 
          this.getPrecCodStock()
        })
        .catch(error => {
          this.getPrecCodStock()
          util.mostrarEnConsola('tiendaApiService - getPreciosByIdArtandIdOp', error, 'ERROR')
        })
     
    },
    getPrecCodStock() {
      for (var i = 0; i < this.articulo.tallas.length; i++) {
         if (this.articulo.tallas[i].tallaInterna === this.tallaInterna) {
            this.talla = this.articulo.tallas[i].talla
            if (this.articulo.tallas[i].stocks.length > 0) {
              // let stockOp 
              // for (var y = 0; y < this.articulo.tallas[i].stocks.length; y++) {
              //   if (this.articulo.tallas[i].stocks[y].unidades > 0) {
              //     stockOp = this.articulo.tallas[i].stocks[y]
              //     break
              //   }
              // }
              // *** SOLO si queremos que haya stock en la tienda seleccionada ****///
              let stockOp = this.articulo.tallas[i].stocks.find( stock => stock.id.id_op === this.opId )
              if (stockOp) {
                if (stockOp.unidades > 0) {
                  this.unidadesDisp = stockOp.unidades
                } else {
                  this.unidades = 0
                }
                if (stockOp.precio) {
                  this.precio = stockOp.precio.precio
                } else {
                  this.precio = ''
                }

              } else{ 
                this.unidadesDisp = 0
                this.precio = ''
                let precioAux = this.precios.find( precio => precio.id.talla_interna == this.articulo.tallas[i].tallaInterna ) 
                if (precioAux !== undefined) {
                  this.precio = precioAux.precio
                }
              }
            }
            else {
              this.unidadesDisp = 0
              this.precio = ''
            }
            //cogemos el codigo
            this.codigo = ''
            if (this.articulo.tallas[i].eans.length > 0) {
              for (var x = 0; x < this.articulo.tallas[i].eans.length; x++) {
                if (!isNaN(this.articulo.tallas[i].eans[x].ean) && this.articulo.tallas[i].eans[x].ean.toString().length === 13) {
                  this.codigo = this.articulo.tallas[i].eans[x].ean
                }
              }
            }
            else {
              //No hay generamos el ean13
              this.codigo = util.generarEan13(this.articulo.tallas[i].tallaInterna,this.articulo.tallas[i].talla,this.articulo.localizador)
            }
         }
      }    
    },
    getFoto(productAux) {
      let url = ''
      if (productAux.fotos) {
        for (var i = 0; i < productAux.fotos.length; i++) {
          if (productAux.fotos[i].porDefecto === "S") {
            if (productAux.fotos[i].url) {
              url=productAux.fotos[i].url
            } else if (productAux.fotos[i].imagenBytes) {
              url = "data:image/png;base64," + productAux.fotos[i].imagenBytes
            }
          } else {
            if (productAux.fotos[i].url) {
              if (url === '') {
                url =  productAux.fotos[i].url
              }
            } else {
              if (url === '') {
                url = "data:image/png;base64," + productAux.fotos[i].imagenBytes
              }
            }
          }
        }
      } 
      if (url === '') {
        return require('@/assets/images/noimg.jpg')
      } else {
        this.foto = url
        return url
      }
    },
    formatMoney (num) {
      return util.formatMoney(num)
    },
    restar () {
      if (this.cantidad > 1) {
        this.cantidad -= 1
      }
    },
    sumar () {
      this.cantidad += 1
    },
    addToCart () {
      if (this.precio !== '' && this.codigo !== '' && this.talla !== '' ) {
        this.error = false
        for (var i = 0; i < this.articulo.tallas.length; i++) {
          if (this.articulo.tallas[i].tallaInterna === this.tallaInterna) {
            if (this.cantidad >= this.total[i]) {
              this.error = true
              this.errorMsj = "No hay suficiente stock"
            } else {
              Object.assign(this.articulo, {stock: this.total[i]})
              Object.assign(this.articulo, {talla: this.articulo.tallas[i].talla})
            }
            break
          }
        }
        if (!this.error) {
          Object.assign(this.articulo, {cantidad: this.cantidad})
          Object.assign(this.articulo, {codigo: this.codigo})
          Object.assign(this.articulo, {precio: this.precio})
          Object.assign(this.articulo, {foto: this.foto})
          this.$store.commit('addToCart', this.articulo)
          this.$emit('cerrar')
        }
      } else {
        this.error = true
        this.errorMsj = "Ha ocurrido un error"
        console.log(this.codigo + " " + this.precio + " " + this.talla)
      }
    },
    getStock() {
      let pass
      this.stock = [[]]
      this.tallas = []
      this.total =[]
      this.ops = []
      for (var i = 0; i < this.articulo.tallas.length; i++) {
        this.tallas.push(this.articulo.tallas[i].talla)
        this.total.push(0)
        //stock.push(this.articulo.tallas[i].talla)
        this.stock[i] = new Array(this.ops.length)
        for (var y = 0; y < this.articulo.tallas[i].stocks.length; y++) {
          pass = false
          for (var z = 0; z < this.ops.length; z++) {
            //alert(this.articulo.tallas[i].stocks[y].unidades)
            if (this.articulo.tallas[i].stocks[y].op !== null) {
              if (this.ops[z] === this.articulo.tallas[i].stocks[y].op.msopclicode) {
                if (this.articulo.tallas[i].stocks[y].unidades > 0) {
                  if (!isNaN(this.stock[i][z])) {
                    this.stock[i][z] = this.stock[i][z] + this.articulo.tallas[i].stocks[y].unidades
                    this.total[i] += this.articulo.tallas[i].stocks[y].unidades
                  } else {
                    this.stock[i][z] = this.articulo.tallas[i].stocks[y].unidades
                    this.total[i] += this.articulo.tallas[i].stocks[y].unidades
                  }
                  // console.log(this.articulo.tallas[i].stocks[y].id.id_op)
                  pass = true
                }
              }
            }
          }
          if (!pass) {
            let tiendaAux = this.tiendas.find( tienda => tienda.msopid === this.articulo.tallas[i].stocks[y].id.id_op )
            if (tiendaAux) {
              if (this.articulo.tallas[i].stocks[y].unidades > 0) {
                if (this.tallaInterna === '') {
                  this.tallaInterna = this.articulo.tallas[i].tallaInterna
                  if (this.articulo.tallas[i].stocks[y].precio) {
                    this.precio = this.articulo.tallas[i].stocks[y].precio.precio
                  }
                }
                // TODO: id de almacen 
                if (tiendaAux.msopid === this.opId || tiendaAux.msopid === 84) {
                  this.ops.unshift(this.articulo.tallas[i].stocks[y].op.msopclicode)
                  this.stock[i].unshift(this.articulo.tallas[i].stocks[y].unidades)
                } else {
                  this.ops.push(this.articulo.tallas[i].stocks[y].op.msopclicode)
                  this.stock[i].push(this.articulo.tallas[i].stocks[y].unidades)
                }
                this.total[i] += this.articulo.tallas[i].stocks[y].unidades
              }
            }
          }
        }
      }
    }
  }
}
</script>